import { type SignupEmailType } from '../../_shared/utils/3rdPartyIntegrations/ga/signupFunnel.helpers';
import {
  apiGet, apiPost,
} from '../../_shared/utils/api/api.helpers';

export type VerifyEmailResponse = {
  message: string;
  // true only on the first verification of a user who owns a new account (not for invited users or repeated links)
  is_new_user?: boolean;
  email_type?: SignupEmailType | null;
  // The BE signs the user in on a successful verification (it sets a short lived auth cookie).
  // The tokens are only returned when that part of the request succeeds.
  refresh?: string;
  access_token_expiration?: string;
};

export const getEmailVerificationRequest = (expires: string, hash: string, id: string, email: string, signature: string): Promise<VerifyEmailResponse> => {
  const requestUrl = '/api/auth/verify';
  return apiGet(requestUrl, {
    expires,
    hash,
    id,
    email: encodeURIComponent(email),
    signature,
  });
};

export const resendEmailVerificationRequest = (userEmail: string): Promise<VerifyEmailResponse> => {
  const requestUrl = '/api/auth/verify/resend';
  return apiPost(requestUrl, {
    email: userEmail,
  });
};
